<template>
  <div class="row">
    <templates-picker
      v-if="!selectedWaTemplate"
      :inbox-id="inboxId"
      :templates-admin="templatesAdmin"
      :template-filter="templateFilters"
      @onSelect="pickTemplate"
    />
    <template v-else>
      <div class="medium-12 text-right">
        <hr class="margin-1 margin-left-0 margin-right-0" />
        <woot-button
          icon="edit"
          size="small"
          variant="smooth"
          class="margin-bottom-1"
          @click="selectedWaTemplate = null"
        >
          {{ $t('WHATSAPP_TEMPLATES.PARSER.GO_BACK_LABEL') }}
        </woot-button>
      </div>
      <template-parser
        :template="selectedWaTemplate"
        :enable-parameterization="isEnableParameterization"
        :type="templateParserType"
        :inbox-id="inboxId"
        @resetTemplate="onResetTemplate"
        @sendMessage="onSendMessage"
      />
    </template>
  </div>
</template>

<script>
import TemplatesPicker from 'dashboard/components/widgets/conversation/WhatsappTemplates/TemplatesPicker.vue';
import TemplateParser from 'dashboard/components/widgets/conversation/WhatsappTemplates/TemplateParser.vue';

export default {
  components: {
    TemplatesPicker,
    TemplateParser,
  },
  props: {
    inboxId: {
      type: Number,
      default: undefined,
    },
    show: {
      type: Boolean,
      default: true,
    },
    templatesAdmin: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectedWaTemplate: null,
    };
  },
  watch: {
    inboxId() {
      this.onResetTemplate();
    },
  },
  methods: {
    pickTemplate(template) {
      this.$emit('pickTemplate', true);
      this.selectedWaTemplate = template;
    },
    onResetTemplate() {
      this.$emit('pickTemplate', false);
      this.selectedWaTemplate = null;
    },
    onSendMessage(message) {
      this.$emit('on-send', message);
    },
    onClose() {
      this.$emit('cancel');
    },
  },
  computed: {
    templateFilters() {
      return {
        marketing: true,
        utility: true,
      };
    },
    isEnableParameterization() {
      return (
        this.$route.name === 'inbox_conversation' ||
        this.$route.name === 'contact_profile_dashboard' ||
        this.$route.name === 'contacts_dashboard'
      );
    },
    templateParserType() {
      if (
        this.$route.name === 'contacts_dashboard' ||
        this.$route.name === 'contact_profile_dashboard'
      ) {
        return 'contact';
      }
      if (this.$route.name === 'inbox_conversation') {
        return 'chat';
      }

      return 'default';
    },
  },
};
</script>
